import { produce } from 'immer';
import { find, xor } from 'lodash/fp';
import { extractError } from 'app/lib/error/errorMappings.js';
import {
    CLOSE_CREATE_DIALOG,
    CLOSE_MIGRATE_DIALOG,
    CREATE_GRAPH,
    CREATE_MIGRATION,
    CREATE_PROJECT,
    LIST_MIGRATIONS,
    MIGRATE_SHEETS,
    OPEN_CREATE_DIALOG,
    OPEN_MIGRATE_DIALOG,
    SELECT_MIGRATION,
    SELECT_SHEET,
    SET_METADATA,
    SET_MIGRATION_SHEETS,
    GET_MIGRATION_FILES,
    TOGGLE_GROUP,
    COLLAPSE_ALL_GROUPS,
    EXPAND_ALL_GROUPS
} from './types.js';
import { Status } from './utils.js';

export const INITIAL_STATE = {
    isCreateDialogOpen: false,
    isMigrateDialogOpen: false,
    isCreatingMigration: false,
    createError: null,
    selectedMigrationId: null,
    selectedSheetId: null,
    migrations: [],
    isMigrationFetched: false,
    migrationSheets: {},
    isLoadingMigrationFiles: false,
    exportJson: null,
    projectUid: null,
    progress: [],
    state: 0,
    expandedGroups: []
};

export const migrationReducer = produce((draft, action) => {
    switch (action.type) {
        case OPEN_CREATE_DIALOG:
            draft.isCreateDialogOpen = true;
            break;

        case CLOSE_CREATE_DIALOG:
            draft.isCreateDialogOpen = false;
            break;

        case OPEN_MIGRATE_DIALOG:
            draft.isMigrateDialogOpen = true;
            break;

        case CLOSE_MIGRATE_DIALOG:
            draft.isMigrateDialogOpen = false;
            draft.state = 0;
            draft.progress = [];
            draft.projectUid = null;
            break;

        case CREATE_MIGRATION.STARTED:
            draft.isCreatingMigration = true;
            break;

        case CREATE_MIGRATION.FAILED:
            draft.createError = extractError(action.payload);
            break;

        case CREATE_MIGRATION.SUCCEEDED:
            draft.isCreateDialogOpen = false;
            break;

        case CREATE_MIGRATION.ENDED:
            draft.isCreatingMigration = false;
            break;
        case LIST_MIGRATIONS.STARTED:
            draft.isMigrationFetched = false;
            break;
        case LIST_MIGRATIONS.SUCCEEDED:
            draft.migrations = action.payload.migrations;
            break;
        case LIST_MIGRATIONS.ENDED:
            draft.isMigrationFetched = true;
            break;
        case SELECT_MIGRATION:
            draft.selectedMigrationId = action.payload.uid;
            draft.selectedSheetId = null;
            break;

        case SELECT_SHEET: {
            draft.selectedSheetId = action.payload.id;
            break;
        }

        case SET_MIGRATION_SHEETS: {
            const { uid, sheets } = action.payload;

            draft.migrationSheets[uid] = sheets;

            break;
        }

        case GET_MIGRATION_FILES.STARTED:
            draft.isLoadingMigrationFiles = true;
            break;

        case GET_MIGRATION_FILES.ENDED:
            draft.isLoadingMigrationFiles = false;
            break;

        case SET_METADATA.SUCCEEDED: {
            const { uid, feMetadata } = action.params;
            const migration = find({ uid }, draft.migrations);

            migration.feMetadata = feMetadata;

            break;
        }

        case MIGRATE_SHEETS:
            draft.state = 1;
            draft.projectUid = action.payload.projectUid;
            break;

        case CREATE_PROJECT.SUCCEEDED:
            draft.projectUid = action.payload.entityId;
            break;

        case CREATE_GRAPH.PROGRESS:
            draft.progress.push({
                type: action.payload.type,
                name: action.payload.name,
                status: Status.CREATED
            });
            break;

        case CREATE_GRAPH.FAILED:
            draft.progress.push({
                type: action.payload.type,
                name: action.payload.name,
                error: action.payload.error.messages[0],
                status: Status.FAILED
            });
            break;

        case CREATE_GRAPH.SUCCEEDED:
            draft.state = 2;
            break;

        case TOGGLE_GROUP: {
            const { id } = action.payload;
            draft.expandedGroups = xor([id], draft.expandedGroups);

            break;
        }

        case COLLAPSE_ALL_GROUPS:
            draft.expandedGroups = [];

            break;
        case EXPAND_ALL_GROUPS: {
            const { ids } = action.payload;
            draft.expandedGroups = ids;

            break;
        }
        default:
            break;
    }
}, INITIAL_STATE);
